import { createAction, props } from '@ngrx/store';
import { IUserRootObject, IUser, IActiveCheckInRoot, IRecentCheckInRoot, IPermissionMapping } from '../../models/user';
import { IPermission } from 'src/app/models/map';
import { Update } from '@ngrx/entity';


export const GetUserDetailsApiAction = createAction('[UserDetails] Get UserDetails');
export const SuccessGetUserDetailsApiAction = createAction('[UserDetails] Success Get UserDetails',
  props<{ userDetails: IUserRootObject }>());
export const ErrorGetUserDetailsApiAction = createAction('[UserDetails] Error Get UserDetails', props<Error>());

export const PostUserDetailsApiAction = createAction('[UserDetails] Post UserDetails', props<{ userDetails: IUser }>());
export const SuccessPostUserDetailsApiAction = createAction('[UserDetails] Success Post UserDetails',
  props<{ userDetails: IUserRootObject }>());
export const ErrorPostUserDetailsApiAction = createAction('[UserDetails] Error Post UserDetails', props<Error>());

export const GetHRApiDetailsApiAction = createAction('[UserDetails] GET HRApiDetails');
export const SuccessGetHRApiDetailsApiAction = createAction('[UserDetails] Success GET HRApiDetails');
export const ErrorGetHRApiDetailsApiAction = createAction('[UserDetails] Error GET HRApiDetails');


export const SetUserTabSelection = createAction('[Set Tab] Set Tab', props<{ tabType: string }>());
export const SetUserHistorySelection = createAction('[Set History] Set History', props<{ value: boolean }>());

export const SetPreviousUrl = createAction('[Set Previous State]', props<{ url: string }>());

export const SetRequestUrl = createAction('[Set Request URL]', props<{ url: string }>());


export const SetAddNewAction = createAction('[Set Add New]', props<{ value: boolean }>());

export const SetUserLevelPermissions = createAction('[Set User Level Permission]', props<{ permission: IPermission[] }>());

export const GetUserRecentDetailsApiAction = createAction('[UserRecent] Get Recent  Checkin');
export const SuccessGetUserRecentDetailsApiAction = createAction('[UserRecent] Success Get User Recent Checkin',
  props<{ recentCheckIn: IRecentCheckInRoot }>());
export const ErrorGetUserRecentDetailsApiAction = createAction('[UserRecent] Error Get User Recent Checkin', props<Error>());

export const GetUserActiveCheckinDetailsApiAction = createAction('[UserActiveCheckin] Get ActiveCheckin Checkin');
export const SuccessGetUserActiveCheckinDetailsApiAction = createAction('[UserRecentTwo] Success Get User ActiveCheckin  Checkin',
  props<{ activeCheckIn: IActiveCheckInRoot }>());
export const ErrorGetUserActiveCheckinDetailsApiAction =
  createAction('[UserRecentTwo] Error Get User ActiveCheckin  Checkin', props<Error>());

export const updateLastScannedSiteAction =
  createAction('[UserDetails] Update Last Scanned Site', props<{ siteId: number }>());

export const GetUserPermissionApiAction = createAction('[UserActiveCheckin] Get Permission Mapping');
export const SuccessGetUserPermissionApiAction = createAction('[UserActiveCheckin] Success Get Permission Mapping', props<{ permissions: IPermissionMapping[] }>());
export const ErrorGetUserPermissionApiAction = createAction('[UserActiveCheckin] Error Get Permission Mapping', props<Error>());
export const UpdateUserPermissionMappingAction = createAction('[UserActiveCheckin] Update Permission Mapping Facilities', props<Update<IPermissionMapping>>());
